import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '../../services/api.service';
import { MessageService } from '../../services/message.service';
import { TranslateService } from '@ngx-translate/core';
import { CROSS } from 'src/defaultImages.js';

@Component({
  selector: 'app-action-prompt-dialog',
  templateUrl: './action-prompt-dialog.component.html',
  styleUrls: ['./action-prompt-dialog.component.css'],
})
export class ActionPromptDialogComponent implements OnInit {
  images = { 
    CROSS: CROSS,
  }
  otp: string;
  translationText: any;
  showOtpComponent = true;
  permission: string;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: true,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '66px',
      height: '66px',
    },
  };
  constructor(
    public dialogRef: MatDialogRef<ActionPromptDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private messageService: MessageService,
    private translateService: TranslateService
  ) {
    this.translateService.use(localStorage.getItem('language') || 'en_US');
    this.permission = data.permission;
  }

  ngOnInit() {
    this.translateService.get(['ORDER_DASHBOARD']).subscribe((translation) => {
      this.translationText = translation.ORDER_DASHBOARD;
    });
  }
  setVal(val) {
    this.ngOtpInput.setValue(val);
  }
  onOtpChange(otp) {
    this.otp = otp;
    if (otp.length === 4) {
      this.verifyStaffPin(otp);
    } else if (otp.length == 0) {
      // this.onConfigChange();
    }
  }
  onConfigChange() {
    this.showOtpComponent = false;
    this.otp = null;
    setTimeout(() => {
      this.showOtpComponent = true;
    }, 0);
  }
  numBack(e) {
    let num = '';
    for (let item in this.ngOtpInput.otpForm.value) {
      if (this.ngOtpInput.otpForm.value[item] != null)
        num += this.ngOtpInput.otpForm.value[item];
    }
    num = num.substr(0, num.length - 1);
    this.ngOtpInput.setValue(num);
    this.onOtpChange(num);
  }
  getNumber(number) {
    let num = '';
    for (let item in this.ngOtpInput.otpForm.value) {
      if (this.ngOtpInput.otpForm.value[item] != null)
        num += this.ngOtpInput.otpForm.value[item];
    }
    num += number;
    this.ngOtpInput.setValue(num);
  }
  verifyStaffPin(pin) {
    const payload = {
      restaurant_id: localStorage.getItem('restaurant_id'),
      staff_cred: this.otp,
    };
    this.apiService.verifyStaff(payload).subscribe(
      (response) => {
        if (response.status == 1) {
          try {
            if (response.permissions.includes(this.permission)) {
              const checkExtraPermission = (this.data || {}).enteredPinHasOtherCheckedPermission;
              const result: { data: any; status: number; message: string; pin?: string; enteredPinHasOtherExtraPermission?: number } = {
                data: response.token,
                status: 1,
                message: 'AUTHORIZED',
                pin: this.otp,
              };
            
              if (checkExtraPermission && response.permissions.includes(checkExtraPermission)) {
                result.enteredPinHasOtherExtraPermission = 1;
              }
            
              this.dialogRef.close(result);
              this.messageService.showSuccess(this.translationText.AUTH);
            } else {
              this.dialogRef.close({
                data: null,
                status: 0,
                message: 'NOT AUTHORIZED',
              });
              this.messageService.showError(this.translationText.YOU_ARE_AUTH);
            }
          } catch {
            this.dialogRef.close({
              data: null,
              status: 0,
              message: 'NOT AUTHORIZED',
            });
            this.messageService.showError(this.translationText.YOU_ARE_AUTH);
          }
        } else {
          this.dialogRef.close({
            data: null,
            status: 0,
            message: 'NOT AUTHORIZED',
          });
          this.messageService.showError(this.translationText.YOU_ARE_AUTH);
        }
      },
      (error) => {
        this.messageService.showError(error.error.message);
      }
    );
  }
  cancel_clicked() {
    this.dialogRef.close({ data: null, status: 0, message: 'NOT AUTHORIZED' });
    this.messageService.showError(this.translationText.YOU_ARE_AUTH);
  }
}
